import React, { useState, useEffect } from 'react';
import { collection, addDoc, deleteDoc, doc, setDoc, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import ScheduleModal from './ScheduleModal';
import './AdminReservations.css';
import './AdminMenuSedes.css';

function AdminMenuSedes() {
    const [error, setError] = useState(null);
    const [sedes, setSedes] = useState([]); // This will hold the data directly from menuSedes
    const [loadingSedes, setLoadingSedes] = useState(true);
    const [newSedeName, setNewSedeName] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentSedeId, setCurrentSedeId] = useState(null);
    const [currentSedeName, setCurrentSedeName] = useState('');

    // Effect to listen to menuSedes directly
    useEffect(() => {
        setLoadingSedes(true);
        const q = query(collection(db, 'menuSedes'), orderBy('name'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const sedesList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setSedes(sedesList);
            setLoadingSedes(false);
        }, (err) => {
            console.error("Error fetching menuSedes: ", err);
            setError("Failed to fetch menu sedes data.");
            setLoadingSedes(false);
        });
        return () => unsubscribe();
    }, []);

    const handleOpenModal = (sedeId, sedeName) => {
        setCurrentSedeId(sedeId);
        setCurrentSedeName(sedeName);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setCurrentSedeId(null);
        setCurrentSedeName('');
    };

    const handleSetSedeVisibility = async (sedeId, sedeName, visibility) => {
        try {
            const sedeRef = doc(db, 'menuSedes', sedeId);
            const data = {
                name: sedeName, // Use name as per user's request
                visible: visibility,
                activationType: 'manual',
                schedule: { lunes: [], martes: [], miércoles: [], jueves: [], viernes: [], sábado: [], domingo: [] } // Ensure schedule is always present
            };
            await setDoc(sedeRef, data, { merge: true }); // Use setDoc with merge to create/update
            alert(`Sede ${visibility ? 'activada' : 'desactivada'} correctamente (modo manual).`);
        } catch (e) {
            console.error("Error setting sede visibility: ", e);
            setError("Error al cambiar la visibilidad de la sede.");
            alert("Error al cambiar la visibilidad de la sede.");
        }
    };

    const handleAddSede = async () => {
        if (newSedeName.trim() === '') return;

        try {
            // When adding a new sede, ensure it has a name and an empty schedule
            await addDoc(collection(db, 'menuSedes'), {
                name: newSedeName,
                visible: true,
                activationType: 'manual',
                schedule: { lunes: [], martes: [], miércoles: [], jueves: [], viernes: [], sábado: [], domingo: [] }
            });
            setNewSedeName('');
        } catch (e) {
            console.error("Error adding document: ", e);
            setError("Error al agregar la sede.");
        }
    };

    const handleDeleteSede = async (id) => {
        try {
            await deleteDoc(doc(db, 'menuSedes', id));
        } catch (e) {
            console.error("Error deleting document: ", e);
            setError("Error al eliminar la sede.");
        }
    };

    if (loadingSedes) {
        return <p>Cargando sedes...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div>
            <h2>Administrar Sedes del Menú</h2>
            <div style={{ marginBottom: '20px' }}>
                <input
                    type="text"
                    value={newSedeName}
                    onChange={(e) => setNewSedeName(e.target.value)}
                    placeholder="Nombre de la nueva sede"
                    style={{ marginRight: '10px', padding: '8px' }}
                />
                <button onClick={handleAddSede} style={{ padding: '8px 12px' }}>Agregar Sede</button>
            </div>
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>Nombre de la Sede</th>
                        <th>Estado</th>
                        <th>Visibilidad</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {sedes.map(sede => (
                        <tr key={sede.id}>
                            <td>{sede.name}</td>
                            <td>
                                <span className={`status-badge status-${sede.activationType || 'manual'}`}>
                                    {sede.activationType === 'scheduled' ? 'Programada' : 'Manual'}
                                </span>
                            </td>
                            <td>{sede.visible ? 'Visible' : 'Oculta'}</td>
                            <td>
                                <button
                                    onClick={() => handleSetSedeVisibility(sede.id, sede.name, true)}
                                    className="action-button activate"
                                    disabled={sede.visible}
                                >
                                    Activar
                                </button>
                                <button
                                    onClick={() => handleSetSedeVisibility(sede.id, sede.name, false)}
                                    className="action-button deactivate"
                                    disabled={!sede.visible}
                                >
                                    Desactivar
                                </button>
                                <button 
                                    onClick={() => handleOpenModal(sede.id, sede.name)}
                                    className="action-button schedule"
                                >
                                    Programar Horario
                                </button>
                                <button
                                    onClick={() => handleDeleteSede(sede.id)}
                                    className="action-button delete"
                                >
                                    Eliminar
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {isModalOpen && (
                <ScheduleModal 
                    sedeId={currentSedeId} 
                    sedeName={currentSedeName} // Pass the name to the modal
                    onClose={handleCloseModal} 
                />
            )}
        </div>
    );
}

export default AdminMenuSedes;